import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";

import "typeface-roboto";

Sentry.init({
  dsn: "https://d59d793a7395da4519eb242ef83d8f24@o4505849459572736.ingest.us.sentry.io/4506951451934720",
  // Crash reporting only in production builds; local dev stays quiet.
  enabled: process.env.NODE_ENV === "production",
  environment: "production",
  initialScope: { tags: { service: "noble-admin" } },
});

const container = document.getElementById("root");
createRoot(container).render(<App />);
